export default "__VITE_ASSET__DaoKLFGN__"